export const scrollToCarline = (
	scroll: number,
	isAutoScrollingRef: React.MutableRefObject<boolean>,
) => {
	isAutoScrollingRef.current = true;

	window.scrollTo({ top: scroll });

	setTimeout(() => {
		isAutoScrollingRef.current = false;
	}, 0);
};

export const scrollToDisclaimerText = (
	reference: string,
	isAutoScrollingRef: React.MutableRefObject<boolean>,
) => {
	//Activamos el autoscroll para que no haya problemas
	isAutoScrollingRef.current = true;

	//Guardamos la posición inicial
	const initialScrollPosition =
		window.pageYOffset || document.documentElement.scrollTop;

	//Obtenemos todos los legales (se localizan por usar dt)
	const allDts = document.querySelectorAll('dt');
	for (const dt of Array.from(allDts)) {
		//Limpiamos el . que tienen el numero del legal (2.)
		if (dt.textContent?.trim() === `${reference}.`) {
			//Cogemos el legal de la lista que tiene dicha referencia (2)
			const li = dt.closest('li');
			if (li) {
				//Ahora cogemos el mensaje del legal para añadirle el (volver arriba)
				const dd = li.querySelector('dd');
				if (dd && !dd.querySelector('.back-to-top')) {
					const span = document.createElement('span');
					span.className = 'back-to-top';
					span.style.cssText =
						'display:block;cursor:pointer;color:inherit;text-decoration:underline;font-weight:bold;';
					span.textContent = '↑ Volver arriba';
					span.onclick = () => {
						//Activamos el auto scroll para volver al legal y desactiamos el autoscroll al pasar 1500ms
						isAutoScrollingRef.current = true;
						window.scrollTo({
							top: initialScrollPosition,
							behavior: 'smooth',
						});
						setTimeout(() => {
							isAutoScrollingRef.current = false;
						}, 1500);
						span.remove();
					};
					dd.appendChild(span);
				}

				//Obtenemos la posicion del legal en la lista
				const rect = li.getBoundingClientRect();
				//Obtenemos cuanto se ha scrolleado ya para tenerlo en cuenta
				const scrollTop =
					window.pageYOffset || document.documentElement.scrollTop;
				//Hacemos scroll automatico con 100 px de margen
				window.scrollTo({
					top: scrollTop + rect.top - 100,
					behavior: 'smooth',
				});
				//Hacemos focus en el legal
				setTimeout(() => {
					li.setAttribute('tabindex', '-1');
					li.focus();
				}, 800);

				//desactivamos el autoscroll
				setTimeout(() => {
					isAutoScrollingRef.current = false;
				}, 1000);

				return;
			}
		}
	}
	isAutoScrollingRef.current = false;
};

export const handleModelListAutoScroll = (
	activeCarlineIndex: number,
	numberOfCarlines: number,
) => {
	const scrollContainer = document.getElementById('scroll-container');
	const lastModelElement = document.getElementById(
		`model-${numberOfCarlines - 1}`,
	);

	if (!scrollContainer || !lastModelElement) return;

	const modelElementHeight = Number(
		lastModelElement?.getBoundingClientRect().height +
			lastModelElement?.style.marginTop,
	);

	//Hacemos scroll hasta el carline
	if (activeCarlineIndex >= 0 && scrollContainer) {
		const visibleElements = Math.floor(
			scrollContainer?.getBoundingClientRect().height / modelElementHeight,
		);

		if (visibleElements && scrollContainer) {
			if (visibleElements < numberOfCarlines) {
				if (activeCarlineIndex > visibleElements / 2) {
					const marginTop =
						-1 *
						modelElementHeight *
						(activeCarlineIndex - visibleElements / 2);
					scrollContainer.style.marginTop = `${marginTop}px`;
				} else {
					scrollContainer.style.marginTop = `${modelElementHeight * 2}px`;
				}
			} else {
				scrollContainer.style.marginTop = `${modelElementHeight * 2}px`;
			}
		}
	}
};
